module.exports = __webpack_public_path__ + "media/img/help_center/Student_Institution_Directory_01-4d1fd7387ebb4e3169272f6e3bfa7896.jpg";